import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AuthService from 'core/auth.service';
import { OpButton } from 'op2mise-react-widgets';

import styles from './ProfileFormModal.module.css';
import { GeneralForm } from '../general-form/GeneralForm';

export default function ProfileFormModal({ onClose }) {
  const formRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);

  // We provide a dummy setIsDirty to fulfill GeneralForm's prop requirement
  const setIsDirty = () => {};

  const handleSave = async () => {
    setIsSaving(true);
    const success = await formRef.current.save();
    setIsSaving(false);

    if (success) {
      // 1. Update the session storage so the modal doesn't pop up again on refresh
      const identity = AuthService.getUserIdentity();
      if (identity) {
        identity.hasCompleteContact = true;
        // Adjust the key below if your app uses a different key name in sessionStorage
        sessionStorage.setItem('userIdentity', JSON.stringify(identity));
      }
      // 2. Close the modal
      onClose();
    }
  };

  return (
    <Modal
      centered
      dialogClassName={styles.profileFormModal}
      // Do nothing on close request to force them to complete the form
      onHide={() => {}}
      size="xl"
      show
    >
      <Modal.Body className={styles.profileFormModalBody}>
        <div className={styles.formTitle}>Update Profile</div>

        <div className={styles.formContent}>
          <GeneralForm ref={formRef} setIsDirty={setIsDirty} />
        </div>

        <div className={styles.formFooter}>
          <OpButton
            disabled={isSaving}
            label="Save"
            loading={isSaving}
            onClick={handleSave}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

ProfileFormModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
